import type { QuoteItem, QuoteItems } from './reducer';

export const types = {
  INIT_QUOTE_PART_VIEWER: 'modules/quotePartViewer/INIT_QUOTE_PART_VIEWER',
  LOCK_QUOTE_ITEM: 'modules/quotePartViewer/LOCK_QUOTE_ITEM',
  RECEIVE_EXPORT_CONTROLLED:
    'modules/quotePartViewer/RECEIVE_EXPORT_CONTROLLED',
  RECEIVE_QUOTE_ITEMS: 'modules/quotePartViewer/RECEIVE_QUOTE_ITEMS',
  RECEIVE_QUOTE_ITEM_UPDATE:
    'modules/quotePartViewer/RECEIVE_QUOTE_ITEM_UPDATE',
  RECEIVE_QUOTE_ID: 'modules/quotePartViewer/RECEIVE_QUOTE_ID',
  RECEIVE_QUOTE_ITEM_ID: 'modules/quotePartViewer/RECEIVE_QUOTE_ITEM_ID',
  RECEIVE_QUOTE_STATUS: 'modules/quotePartViewer/RECEIVE_QUOTE_STATUS',
  REFRESH_QUOTE_ITEMS: 'modules/quotePartViewer/REFRESH_QUOTE_ITEMS',
  DISABLE_VIEWER: 'modules/quotePartViewer/DISABLE_VIEWER',
  ENABLE_VIEWER: 'modules/quotePartViewer/ENABLE_VIEWER',
  RESET: 'modules/quotePartViewer/RESET',
  TAKE_OVER_QUOTE_ITEM: 'modules/quotePartViewer/TAKE_OVER_QUOTE_ITEM',
};

export const quotePartViewer = {
  reset: () => ({
    type: types.RESET,
  }),
  disableViewer: () => ({
    type: types.DISABLE_VIEWER,
  }),
  enableViewer: () => ({
    type: types.ENABLE_VIEWER,
  }),
  init: ({
    quoteNum,
    quoteRevision,
    quoteItemId,
  }: {
    quoteNum: number;
    quoteRevision?: number;
    quoteItemId: number;
  }) => ({
    type: types.INIT_QUOTE_PART_VIEWER,
    payload: { quoteNum, quoteRevision, quoteItemId },
  }),
  lockQuoteItem: () => ({
    type: types.LOCK_QUOTE_ITEM,
  }),
  /**
   * Refetches the quote's items (and its status), keeping the item on screen.
   * For when something added or removed items, e.g. a DXF split into line items.
   */
  refreshQuoteItems: () => ({
    type: types.REFRESH_QUOTE_ITEMS,
  }),
  receiveQuoteItemId: ({
    quoteItemId,
    partSetupState,
    gotoLast,
  }: {
    quoteItemId: number;
    partSetupState?: string; //bitmask number. See `partSetupState.ts` (base 36 encoded)
    gotoLast?: boolean;
  }) => ({
    type: types.RECEIVE_QUOTE_ITEM_ID,
    payload: {
      quoteItemId,
      ...(partSetupState != null && { partSetupState }),
      ...(gotoLast && { gotoLast }),
    },
  }),
  receiveQuoteItems: ({ quoteItems }: { quoteItems: QuoteItems }) => ({
    type: types.RECEIVE_QUOTE_ITEMS,
    payload: { quoteItems },
  }),
  receiveQuoteItemUpdate: ({
    quoteItem,
  }: {
    quoteItem: Partial<QuoteItem>;
  }) => ({
    type: types.RECEIVE_QUOTE_ITEM_UPDATE,
    payload: { quoteItem },
  }),
  receiveExportControlled: ({
    exportControlled,
  }: {
    exportControlled?: boolean;
  }) => ({
    type: types.RECEIVE_EXPORT_CONTROLLED,
    payload: { exportControlled },
  }),
  receiveQuoteId: ({ id }: { id?: number }) => ({
    type: types.RECEIVE_QUOTE_ID,
    payload: { id },
  }),
  receiveQuoteStatus: ({ quoteStatus }: { quoteStatus?: string }) => ({
    type: types.RECEIVE_QUOTE_STATUS,
    payload: { quoteStatus },
  }),
  takeOverQuoteItem: ({ quoteItemId }: { quoteItemId?: number }) => ({
    type: types.TAKE_OVER_QUOTE_ITEM,
    payload: { quoteItemId },
  }),
};
